import styled from 'styled-components';
import { Select } from '@material-ui/core';

export const SelectInput = styled(Select)`
  margin: 16px 0;
  width: 100%;
`;
